import { GridCellParams } from '@mui/x-data-grid';
import { CopyToClipboardButton } from '../CopyToClipboard/CopyToClipboardButton';

/**
 * The grid's copy button: the shared control, with the value read off the cell's row id unless the
 * caller names another.
 *
 * Named apart from `CopyToClipboardButton` it wraps, rather than shadowing it: the two take different
 * props — a cell and an optional override here, a plain string there — so a mistaken import was a
 * type error at best and, where a `value` was passed, a button that silently copied nothing at worst.
 */
export const GridCopyButton: React.FC<{ params: GridCellParams; value?: string }> = ({ params, value, ...props }) => (
  // `String` rather than a cast: row ids are numbers here, so `params.id as string` was a lie that
  // happened to work only because it was passed straight to the clipboard.
  <CopyToClipboardButton value={value ?? String(params.id)} {...props} />
);
